// extracted by mini-css-extract-plugin
export default {"containerDefault":"Circle_containerDefault__xOl4C"};